import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { isMobile } from '@libraries/ui-state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-navigation-secondary',
  templateUrl: './app-navigation-secondary.component.html',
  styleUrls: ['./app-navigation-secondary.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationSecondaryComponent {
  isMobile$ = this.store.select(isMobile);
  @Input() title = '';
  @Input() subTitle = '';
  @Input() showBackButton = false;
  @Input() showSubTitleInMobile = false;
  @Input() showTitleHeader = true;
  @Input() showSecondaryButton = false;
  @Input() secondaryButtonLoading = false;
  @Input() backButtonIcon: IconProp = ['fas', 'chevron-left'];
  @Input() secondaryButtonIcon: IconProp = ['fas', 'ellipsis-v'];
  @Output() backButtonClick = new EventEmitter();
  @Output() secondaryButtonClick = new EventEmitter();

  constructor(private store: Store) {}
}
